import { CurrencyBitcoin } from "@mui/icons-material";
import { ChartType } from "src/utils/types";

// Time filter options for portfolio trading view chart
export const TIME_FILTER_OPTIONS = ["1D", "1W", "1M", "3M", "6M", "1Y", "All"];

export const BALANCE_DROPDOWN_TOOLTIP =
  "Your Total Portfolio balance in dollar value can be seen here along with 24 hour changes.";

export const BEST_PERFORMERS_TOOLTIP =
  "Your Total Portfolio balance in dollar value can be seen here along with 24 hour changes.";

export const SUMMARY_TOOLTIP =
  "Your summary highlights your key transactions (target & trade) along with your portfolio change and referrals.";

export const DONUT_CHART_COLORS = ["#003C63", "#FC4C4C", "#CCC3AE"];

export const TRENDING_API_PARAMS = {
  pricingData: true,
  limit: 5,
  quote: "USD",
};

// Some generic tooltip message for InfoIcon
export const DEFAULT_TOOLTIP_MESSAGE = "This is a default tooltip message";

export interface ITimePeriodOption {
  name: string; // Name of the option
  value: "1D" | "1M" | "3M" | "6M" | "9M" | "1Y" | "ALL"; // Value of the option
  label: string; // Label of the option
  link?: string; // Link to the option for how to
}
export const TIME_PERIOD_OPTIONS: ITimePeriodOption[] = [
  { name: "today", value: "1D", label: "today" },
  { name: "monthly", value: "1M", label: "last 30 days" },
  { name: "Quarterly", value: "3M", label: "last 90 days" },
  { name: "annual", value: "1Y", label: "last 1 year" },
  { name: "all time", value: "ALL", label: "all time" },
];

export const TIME_PERIOD_OPTIONS_HOWTO: ITimePeriodOption[] = [
  {
    name: "How to trade",
    link: "https://support.calebandbrown.com/en/articles/6575819-how-do-i-trade-with-caleb-brown",
    value: "1D",
    label: "How to trade",
  },
  {
    name: "How to deposit",
    link: "https://support.calebandbrown.com/en/articles/3129827-how-do-i-deposit-fiat",
    value: "1M",
    label: "How to deposit",
  },
  {
    name: "How to set targets",
    link: "https://support.calebandbrown.com/en/articles/11182116-how-to-place-a-target-order-limit-order",
    value: "3M",
    label: "How to set targets",
  },
  {
    name: "Related articles",
    link: "https://support.calebandbrown.com/en/articles/7954752-frequently-read-help-articles",
    value: "1Y",
    label: "Related articles",
  },
];

// Interface for chart compare options
export interface ICompareOptions {
  name: string; // Name of the option
  checked: boolean; // Whether the option is checked or not
  bgColor: string;
  borderColor: string;
}

// Compare options for portfolio trading view chart
export const COMPARE_OPTIONS: ICompareOptions[] = [
  {
    name: "Bitcoin",
    checked: false,
    bgColor: "#CCC3AE",
    borderColor: "#DED8CA",
  },
  {
    name: "Ethereum",
    checked: false,
    bgColor: "#005790",
    borderColor: "#C2E7FF",
  },
];

// Interface for the Balance component data
export interface IBalanceData {
  balance: string; // Current balance
  change: string; // Change in balance
  dollarChange: string; // Dollar change in balance
  bestPerformers: IBestPerformers[]; // Array of best performers
  unformattedValues?: any; // Unformatted values
}

// Interface for best performers
export interface IBestPerformers {
  name: string; // Name of the performer
  icon: JSX.Element; // Icon for the performer
  amount: string; // Amount of performer
  percent: JSX.Element; // Percentage change of performer
  code: string; // Code of the token
}

export const HOLDINGS_DATA_DEFAULT: ChartType[] = [
  {
    value: 1500,
    pending: 12,
    total: 1512,
    balance: 1500,
    name: "Bitcoin",
    cryptoLogo: "",
    icon: <CurrencyBitcoin />,
  },
  {
    value: 400,
    pending: 20,
    total: 430,
    balance: 400,
    name: "Doge",
    cryptoLogo: "",
    icon: <CurrencyBitcoin />,
  },
  {
    value: 250,
    pending: 40,
    total: 290,
    balance: 250,
    name: "Tether",
    cryptoLogo: "",
    icon: <CurrencyBitcoin />,
  },
];

// Best performers for portfolio
export const BEST_PERFORMERS_DEFAULT: IBestPerformers[] = [
  {
    name: "Bitcoin",
    icon: <CurrencyBitcoin />,
    amount: "$xxxxxxxxxxxx",
    percent: <>"+X%"</>,
    code: "btc",
  },
  {
    name: "Ethereum",
    icon: <CurrencyBitcoin />,
    amount: "$xxxxxxxxxxxx",
    percent: <>"+X%"</>,
    code: "eth",
  },
  {
    name: "Tether",
    icon: <CurrencyBitcoin />,
    amount: "$xxxxxxxxxxxx",
    percent: <>"+X%"</>,
    code: "usdt",
  },
];

// Default balance data for portfolio
export const BALANCE_DATA_DEFAULT: IBalanceData = {
  balance: "",
  change: "0%",
  dollarChange: "0",
  unformattedValues: {},
  bestPerformers: BEST_PERFORMERS_DEFAULT,
};

export interface IWatchlistData {
  name: string;
  code: string;
  currencyConfig?: any;
  icon: string | JSX.Element;
  rawPrice: number;
  price: string;
  sparkline: string[];
  change: JSX.Element;
  marketCap: string;
  favourite: boolean;
  alert: boolean;
  // portfolio data
  units?: string;
}

export const WATCHLIST_DATA_DEFAULT: IWatchlistData[] = [
  {
    name: "Bitcoin",
    code: "btc",
    icon: "",
    rawPrice: 39703.2,
    price: "39703.2",
    sparkline: [],
    change: <>1.2</>,
    marketCap: "60000",
    favourite: true,
    alert: false,
  },
  {
    name: "Ethereum",
    code: "eth",
    icon: "",
    rawPrice: 39703.2,
    price: "39703.2",
    sparkline: [],
    change: <>1.2</>,
    marketCap: "40000",
    favourite: true,
    alert: false,
  },
  {
    name: "Tether",
    code: "thr",
    icon: "",
    rawPrice: 39703.2,
    price: "39703.2",
    sparkline: [],
    change: <>1.2</>,
    marketCap: "20000",
    favourite: true,
    alert: false,
  },
  {
    name: "DogeCoin",
    code: "doge",
    icon: "",
    rawPrice: 39703.2,
    price: "39703.2",
    sparkline: [],
    change: <>1.2</>,
    marketCap: "14000",
    favourite: true,
    alert: false,
  },
  {
    name: "Shiba Inu",
    code: "shiba",
    icon: "",
    rawPrice: 39703.2,
    price: "39703.2",
    sparkline: [],
    change: <>1.2</>,
    marketCap: "11000",
    favourite: true,
    alert: false,
  },
];

export const WATCHLIST_TRENDING_DATA_DEFAULT: IWatchlistData[] = [
  {
    name: "Shiba Inu",
    code: "shiba",
    icon: "",
    rawPrice: 39703.2,
    price: "39703.2",
    sparkline: [],
    change: <>1.2</>,
    marketCap: "11000",
    favourite: false,
    alert: false,
  },
  {
    name: "DogeCoin",
    code: "doge",
    icon: "",
    rawPrice: 39703.2,
    price: "39703.2",
    sparkline: [],
    change: <>1.2</>,
    marketCap: "14000",
    favourite: true,
    alert: false,
  },
  {
    name: "Ethereum",
    code: "eth",
    icon: "",
    rawPrice: 39703.2,
    price: "39703.2",
    sparkline: [],
    change: <>1.2</>,
    marketCap: "40000",
    favourite: true,
    alert: false,
  },
  {
    name: "Bitcoin",
    code: "btc",
    icon: "",
    rawPrice: 39703.2,
    price: "39703.2",
    sparkline: [],
    change: <>1.2</>,
    marketCap: "60000",
    favourite: true,
    alert: false,
  },
  {
    name: "Tether",
    code: "thr",
    icon: "",
    rawPrice: 39703.2,
    price: "39703.2",
    sparkline: [],
    change: <>1.2</>,
    marketCap: "20000",
    favourite: false,
    alert: false,
  },
];

export interface ISummaryData {
  type: string; // Type of the summary data
  value: number | null; // Value of the type summary data
}

export const SUMMARY_DATA_DEFAULT: ISummaryData[] = [
  {
    type: "Targets",
    value: 10,
  },
  {
    type: "Trades",
    value: 15,
  },
  {
    type: "Portfolio",
    value: 0,
  },
  {
    type: "Referrals",
    value: 2,
  },
];

export const SUMMARY_TOOLTIPS: Record<string, string> = {
  Trades: "Number of trades you have made",
  "Open targets": "Number of open targets you have made",
  Portfolio: "Number of assets in your portfolio",
  Referrals: "Number of referrals you have made",
};

export interface IRecentTransactionData {
  type: string;
  ctid: string;
  value: string;
  date: string;
}

export const RECENT_TRANSACTION_DATA_DEFAULT: IRecentTransactionData[] = [
  {
    type: "deposit",
    ctid: "CT123729",
    value: "1000",
    date: "24 Feb 2022",
  },
  {
    type: "trade",
    ctid: "CT123729",
    value: "5000",
    date: "24 Feb 2022",
  },
  {
    type: "airdrop",
    ctid: "CT123729",
    value: "0.01",
    date: "24 Feb 2022",
  },
  {
    type: "airdrop",
    ctid: "CT123729",
    value: "0.01",
    date: "24 Feb 2022",
  },
];

export interface INewsData {
  title: string;
  source: string;
  date: string;
  link: string;
}

export const NEWS_DATA_DEFAULT: INewsData[] = [
  {
    title: "First Mover Asia: Bitcoin Hovers Near $30.3K After xssdsdsfdfsfsalkefbalshrb",
    source: "Decrypt",
    date: "17 Jul 2023",
    link: "https://cointelegraph.com/news/defi-sector-tvl-rises-as-investors-return-to-a-bullish-crypto-market",
  },
  {
    title: "Today Crypto News sucks",
    source: "CNBC",
    date: "17 Jul 2023",
    link: "https://cointelegraph.com/news/defi-sector-tvl-rises-as-investors-return-to-a-bullish-crypto-market",
  },
  {
    title: "Hi please view I am a news link",
    source: "Bloomberg",
    date: "17 Jul 2023",
    link: "https://cointelegraph.com/news/defi-sector-tvl-rises-as-investors-return-to-a-bullish-crypto-market",
  },
  {
    title: "Wow Bitcoin is at its All time High again! Thanks to a mysterious whale",
    source: "Caleb & Brown",
    date: "17 Jul 2023",
    link: "https://cointelegraph.com/news/defi-sector-tvl-rises-as-investors-return-to-a-bullish-crypto-market",
  },
  {
    title: "First Mover Asia: Bitcoin Hovers Near $30.3K After xssdsdsfdfsfsalkefbalshrb",
    source: "bla bla bla",
    date: "17 Jul 2023",
    link: "https://cointelegraph.com/news/defi-sector-tvl-rises-as-investors-return-to-a-bullish-crypto-market",
  },
];

export interface IReferralData {
  value: string | number;
  percent: string;
  code: string;
}

export const REFERRAL_DATA_DEFAULT: IReferralData = {
  value: 0,
  percent: "x",
  code: "",
};
